// Shared utility — auto-link INTIVIV™ product mentions to the store.
// Used by VIVI Coach and Education / Article Reader.

const STORE_URL = 'https://www.intiviv.com';

// Order matters: match longer / more specific names first.
const PRODUCT_PATTERNS = [
  /INTIVIV(?:™|\u2122|<sup>TM<\/sup>)?\s+Intimate\s+Balance\s+Cleanser/gi,
  /INTIVIV(?:™|\u2122|<sup>TM<\/sup>)?\s+Intimate\s+Silk\s+Lubricant/gi,
  /INTIVIV(?:™|\u2122|<sup>TM<\/sup>)?\s+Intimate\s+Comfort\s+Moisturi[zs]er/gi,
  /INTIVIV(?:™|\u2122|<sup>TM<\/sup>)?\s+Sensual\s+Massage\s+Oil/gi,
  /INTIVIV(?:™|\u2122|<sup>TM<\/sup>)?\s+Sensual\s+Intimate\s+Oil/gi,
  /INTIVIV(?:™|\u2122|<sup>TM<\/sup>)?\s+Intimate\s+Freshness\s+Mist/gi,
  /\bIntimate\s+Balance\s+Cleanser\b/gi,
  /\bIntimate\s+Silk\s+Lubricant\b/gi,
  /\bIntimate\s+Comfort\s+Moisturi[zs]er\b/gi,
  /\bSensual\s+Massage\s+Oil\b/gi,
  /\bSensual\s+Intimate\s+Oil\b/gi,
  /\bIntimate\s+Freshness\s+Mist\b/gi,
];

// HTML-string linkifier — for innerHTML usage.
export function linkifyProductsHtml(html, opts = {}) {
  if (!html) return html;
  const testid = opts.testid || 'product-link';
  let out = html;
  for (const re of PRODUCT_PATTERNS) {
    out = out.replace(re, (m) =>
      `<a href="${STORE_URL}" target="_blank" rel="noopener noreferrer" class="vivi-product-link" data-testid="${testid}">${m}<i class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i></a>`
    );
  }
  return out;
}

// React-element linkifier — returns array of strings + <a> elements for safe rendering inside JSX.
export function linkifyProductsReact(text, key = 0) {
  if (!text) return text;
  const parts = [text];
  for (const re of PRODUCT_PATTERNS) {
    for (let i = 0; i < parts.length; i++) {
      const p = parts[i];
      if (typeof p !== 'string') continue;
      const matches = [...p.matchAll(re)];
      if (matches.length === 0) continue;
      const split = [];
      let last = 0;
      matches.forEach((m, mi) => {
        if (m.index > last) split.push(p.slice(last, m.index));
        split.push({ __link: m[0], __k: `${i}-${mi}` });
        last = m.index + m[0].length;
      });
      if (last < p.length) split.push(p.slice(last));
      parts.splice(i, 1, ...split);
      i += split.length - 1;
    }
  }
  return parts.map((p, idx) => {
    if (typeof p === 'string') return p;
    return (
      <a
        key={`${key}-${p.__k}`}
        href={STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="vivi-product-link"
        data-testid="article-product-link"
      >
        {p.__link}
        <i className="fa-solid fa-arrow-up-right-from-square" aria-hidden="true" style={{ marginLeft: 4, fontSize: '0.7em' }} />
      </a>
    );
  });
}
